export const ContractArchiveArchiveRouting = [
  {
    path: "/contract-archive/archive",
    name: "contract-archive-archive",
    meta: { title: "合同归档" },
    component: () =>
      import("@/views/contract-archive/archive/list/index.vue"),
  },
];
